import { makeStyles } from 'tss-react/mui';

const name = 'BalanceCard';

export const useBalanceCardStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(3),
    },
  },
}));
